export const emailReg =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export const CARD = 'card';
export const PAYMENT = 'payment';

export const EXCEPTION_REGEXP = /\\?"?\s*?exception:\w+:/gi;
